<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>Campaign View Settings</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />

        <div class="vx-row p-5">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Auto Size Cell Contents:
            </span>
          </div>


          <div class="vx-col sm:w-1/2 w-full">
            <vs-radio
            v-model="campaign_view_settings.auto_size_cell_contents"
            vs-value="enabled"
            ><span class="ml-5 mr-5">Enabled </span></vs-radio
          >
          <vs-radio
          v-model="campaign_view_settings.auto_size_cell_contents"
          vs-value="disabled"
          ><span class="ml-5">Disabled </span></vs-radio
        >

        <br>
        <vs-button class="mt-10" @click.prevent="submitSDCampaignViewSettings">Submit</vs-button>

        
          </div>
          
        </div>
      
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import axios from "@/axios.js";
import _ from "lodash";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
      user_id:null,
      user_role:null,
      authorized:true,
      abilities : null,
      campaign_view_settings: {
        auto_size_cell_contents : null
      }
    };
  },
  components: {
    "v-select": vSelect
  },
  created() {
     var self = this
     let userInfo = JSON.parse(localStorage.getItem("userInfo"));
     this.user_id = userInfo["uid"];
     this.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    }); 
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (this.user_role == 'Client Administrator' || this.user_role == 'Client'){
      this.authorized = false
      this.$router.replace("/unauthorized")
    }


  },
  mounted() {
    if(this.authorized){
      this.init();
    }
  },
  methods: {
    submitSDCampaignViewSettings() {
      let self = this
      self.campaign_view_settings.sales_developer_id = self.user_id 
      self.$store
        .dispatch("campaignsManagement/submitSDCampaignViewSettings", self.campaign_view_settings)
        .then(res => {
          if (res) {
            if (res.data.status == "success") {
             location.reload()
            }
          }
        })
        .catch(err => {
          console.log(err);
        });


    },
    init() {
      let self = this
      let data = {}
      data.user_id = self.user_id 
      self.$store
        .dispatch("campaignsManagement/fetchAllSDCampaignViewSettings", data)
        .then(res => {
          let result = res.data
          if (result){
            let result_data = JSON.parse(res.data);
            

            let newObj = {}

            result_data.forEach(function(ele){
              newObj[ele.setting_type] = ele.status

            });

            self.campaign_view_settings = newObj
                

          }

    })
    },
    goBack: function() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
